var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "marking-monitoring cnt1200" },
    [
      _c("page-header", {
        attrs: { title: _vm.title, paths: ["考试列表", "批阅监控"] },
      }),
      _c(
        "div",
        { staticClass: "monitoring-part" },
        [
          _c("div", { staticClass: "part-btns" }, [
            _c(
              "div",
              _vm._l(_vm.btns, function (btn, index) {
                return _c(
                  "el-button",
                  {
                    key: "btn" + index,
                    attrs: { type: _vm.activeBtn === btn ? "primary" : "" },
                    on: {
                      click: function ($event) {
                        return _vm.routerTo(btn)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(btn.name) + " ")]
                )
              }),
              1
            ),
            _vm.$route.query.isGrading === "GRADING_DONE" && !_vm.isRegion
              ? _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.exportData },
                      },
                      [_vm._v("导出数据")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c(
            "keep-alive",
            [
              _c("router-view", {
                attrs: {
                  isClassMark: _vm.isClassMark,
                  assignMode: _vm.assignMode,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("export-modal", {
        ref: "exportModal",
        attrs: { reportList: _vm.reportList },
        on: { "click-item": _vm.clickItem },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }